import { createSelector } from "reselect";
import { sectionsSelector } from "../../sections_selector";

export const surveySectionSelector = createSelector(
  sectionsSelector,
  sections => {
    return sections.survey;
  }
);
